import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { Loader, CustomTable } from 'src/components'
import OffsetByExcelSteps from '../OffsetByExcelSteps'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { purchasePreparedColumns } from 'src/core/table-columns'
import { getOffsetPreviewErrorLabel, showNotification } from 'src/core/helpers'
import PreviewPurchasesListHeader from './PreviewPurchasesListHeader/PreviewPurchasesListHeader'
import {
  makeOffsetPurchases,
  setOffsetByExcelStep,
  offsetByExcelSelector,
  preparePurchasesForOffset,
  integrationStaticsSelector,
  getOffsetByExcelRequestData,
  offsetByExcelPrepareSelector,
  integrationProjectListSelector,
  offsetByExcelMakePurchasesSelector,
} from 'src/features'

const PreviewPurchasesStep: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const purchasesReq = useAppSelector(getOffsetByExcelRequestData)
  const { offsetKeys, excelData } = useAppSelector(offsetByExcelSelector)
  const { data: integration } = useAppSelector(integrationStaticsSelector)
  const { data: integrationProjects } = useAppSelector(integrationProjectListSelector)
  const { loading: loadingPurchases, hasFinished } = useAppSelector(offsetByExcelMakePurchasesSelector)
  const {
    loading: loadingData,
    data: preparedPurchaseList,
    selectedProjectId
  } = useAppSelector(offsetByExcelPrepareSelector)

  const { co2UnitField, identifierField, amountCo2Field } = offsetKeys
  const { integration_token } = integration

  const handleSubmitClick = () => {
    if (!selectedProjectId) {
      showNotification('error', t('developers.OffSet.ProjectsWarning'))
      return
    }
    dispatch(makeOffsetPurchases(purchasesReq, integration_token))
  }

  useEffect(() => {
    dispatch(preparePurchasesForOffset(excelData, identifierField, integration_token, amountCo2Field))
  }, [dispatch, co2UnitField, excelData, identifierField, integration_token, amountCo2Field])


  useEffect(() => {
    if (hasFinished) dispatch(setOffsetByExcelStep(3))
  }, [dispatch, hasFinished])

  const purchaseData = preparedPurchaseList?.map(x => {
    return { ...x, keys: offsetKeys }
  })

  return <div className='fade-animation'>
    {loadingData ? <Loader /> : <>
      <PreviewPurchasesListHeader
        length={purchaseData?.length}
        integrationProjects={integrationProjects}
      />
      <CustomTable
        columns={purchasePreparedColumns}
        dataSource={purchaseData}
      />
    </>}

    <OffsetByExcelSteps
      nextStepValue={3}
      beforeStepValue={1}
      handleSubmitClick={handleSubmitClick}
      handleBackClick={() => dispatch(setOffsetByExcelStep(1))}
      isNextButtonDisabled={purchaseData?.length === 0 || !selectedProjectId}
      showTooltipError={purchaseData?.length === 0 || !selectedProjectId}
      tooltipLabel={getOffsetPreviewErrorLabel(t, purchaseData, selectedProjectId)}
      loading={loadingPurchases}
    />
  </div>
}

export default PreviewPurchasesStep
